import dynamic from 'next/dynamic'

export const CTASection = dynamic(() => import('./cta-section'))
